// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_dock_management_styles" + "." + "2f91bcf0" + ".chunk.css";
};